"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DigitalAudiencesTable;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _semanticUiReact = require("semantic-ui-react");

var _campaignCreator = require("../../../actions/campaignCreator");

var _helpers = require("../../../helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function DigitalAudiencesTable(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _campaignCreator.loadDigitalAudiencesVendors)());
  }, [dispatch]);

  var _useState = (0, _react.useState)('name'),
      sortColumn = _useState[0],
      setSortColumn = _useState[1];

  var _useState2 = (0, _react.useState)('ascending'),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var digitalAudiencesRecords = props.digitalAudiencesRecords;

  if (!digitalAudiencesRecords || digitalAudiencesRecords.length === 0) {
    return /*#__PURE__*/_react["default"].createElement("h3", {
      className: "data-workflow-table__no-results"
    }, "Select personas from the menu on the left to view data");
  }

  var setState = function setState(sortObject) {
    if (sortObject.sortColumn) {
      setSortColumn(sortObject.sortColumn);
    }

    if (sortObject.sortDirection) {
      setSortDirection(sortObject.sortDirection);
    }
  };

  var container = {
    state: {
      sortColumn: sortColumn,
      sortDirection: sortDirection
    },
    setState: setState
  };

  var handleSortChange = function handleSortChange(clickedColumn) {
    return function () {
      return (0, _helpers.sortChangeHandler)(clickedColumn, container);
    };
  };

  var sort = function sort(a, b) {
    return (0, _helpers.sortData)(a, b, container);
  };

  var options = [];
  digitalAudiencesRecords.forEach(function (r) {
    var option = {
      key: r.category,
      text: r.category,
      value: r.category
    };
    var idx = options.findIndex(function (o) {
      return o.key === r.category;
    });

    if (idx < 0) {
      options.push(option);
    }
  }); //Some record names have whitespace around name, trimming for proper sorting

  var trimmedNames = digitalAudiencesRecords.map(function (record) {
    return _extends({}, record, {
      name: record.name.trim()
    });
  });

  var TableHeader = /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Header, {
    className: "data-workflow-table__header"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, {
    width: 6,
    sorted: sortColumn === 'name' ? sortDirection : null,
    onClick: handleSortChange('name'),
    textAlign: "left"
  }, "Audience Delivery"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, {
    width: 1,
    sorted: sortColumn === 'total' ? sortDirection : null,
    onClick: handleSortChange('total'),
    textAlign: "right"
  }, "Audience Size"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, {
    width: 2,
    sorted: sortColumn === 'category' ? sortDirection : null,
    onClick: handleSortChange('category'),
    textAlign: "left"
  }, "Channel"), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.HeaderCell, {
    width: 3
  })));

  var Rows = trimmedNames ? Object.values(trimmedNames).sort(sort) : [];
  Rows = Rows.map(function (record, key) {
    // Split the decription into individual records, then split from name and map
    var splitDescription = record.description.split('\n');
    var mappedDescription = splitDescription.map(function (description, i) {
      var split = description.split(' - ');

      if (split.length > 1) {
        return {
          name: split[1],
          description: split[0]
        };
      } else {
        return {
          name: record.name,
          description: split[0]
        };
      }
    });
    return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, {
      className: "digital-audiences-table__row",
      key: key
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
      width: 6
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "audience-delivery--wrapper"
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Image, {
      className: "audience-delivery--image",
      src: record.image,
      size: "small",
      style: {
        maxWidth: '80px'
      }
    }), record.name)), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
      width: 1,
      style: {
        textAlign: 'right'
      }
    }, record.total.toLocaleString()), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
      width: 2,
      textAlign: "left"
    }, record.category), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
      width: 3
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal, {
      className: "digital-audiences-table--modal",
      trigger: /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, null, "Getting Started")
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Content, null, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Modal.Description, null, mappedDescription.map(function (record, i) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: i
      }, /*#__PURE__*/_react["default"].createElement("h6", null, record.name), /*#__PURE__*/_react["default"].createElement("p", null, record.description));
    }))))));
  });
  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table, {
    sortable: true,
    stackable: true,
    striped: true,
    className: "grouped-persona-table digital-audiences-table"
  }, TableHeader, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Body, null, Rows, Rows.length <= 0 && /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Row, {
    className: "data-workflow-table__row"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Table.Cell, {
    colSpan: 6,
    className: "data-workflow-table__empty-table"
  }, "No results available."))));
}